import { render, staticRenderFns } from "./DriverTicketList.vue?vue&type=template&id=a473404e&scoped=true&"
import script from "./DriverTicketList.vue?vue&type=script&lang=js&"
export * from "./DriverTicketList.vue?vue&type=script&lang=js&"
import style0 from "./DriverTicketList.vue?vue&type=style&index=0&id=a473404e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a473404e",
  null
  
)

export default component.exports